module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CT"
  }, [_vm._v("Rail Fence")]), _vm._v(" "), _c('p', {
    staticClass: "CH-INTRO1"
  }, [_vm._v("The Rail Fence design is made by sewing together three long strips of different fabrics and then re-cutting this band into squares. The squares are arranged and joined together to make the block. This block can be used very effectively to make a larger quilt, turning the blocks through 90 degrees each time so that the strips make a pattern of steps running diagonally across the quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/CarolWood_RailFence_Bl_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Colour Choices")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("For this block you need three fabrics. Fold the fabrics into narrow strips and place them next to each other on a flat surface so that you can see how effective they look together. Alternatively, cut four strips of each fabric "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("in × 1"), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("in (1.3cm × 3.8cm) and arrange them in various combinations until you get the best effect.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("Directions")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("1 From each fabric cut one strip 2"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (6.3cm) wide and 28in (71.1cm) long (or two strips each 14in/35.5cm long). Stitch the three strips together using a scant "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (6mm) seam. Try not to stretch the strips but guide them gently. Alternate the direction you sew the strips to keep the band straight not slightly rippled ("), _c('a', {
    attrs: {
      "href": "#/#fig-1"
    }
  }, [_vm._v("Fig 1")]), _vm._v("). Press the band from the front with the seams all in one direction.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/rail-fence-fig1_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-1"
    }
  }, [_vm._v("Fig 1")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("2 Place the band horizontally on the cutting board, lining up the top edge with one of the horizontal markings on the board. Measure the width of the band – it should be 6"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (16.5cm). Using the rotary ruler and cutter, trim one end of the band to straighten it and cut four sections each 6"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (16.5cm) long, to make four squares ("), _c('a', {
    attrs: {
      "href": "#/#fig-2"
    }
  }, [_vm._v("Fig 2")]), _vm._v("). Note: if your band does not measure 6"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (16.5cm), even if it is only "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _vm._v("in (3mm) out, take the measurement you have and cut the four squares to match it. This way you will have true squares, even if they are slightly more or less than intended. You can make adjustments later on if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/rail-fence-fig2_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-2"
    }
  }, [_vm._v("Fig 2")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("3 Arrange the four squares to make the block design ("), _c('a', {
    attrs: {
      "href": "#/#fig-3"
    }
  }, [_vm._v("Fig 3")]), _vm._v("). Pin and machine stitch the top two squares together with a "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (6mm) seam. If the two edges do not match exactly, pin and stitch with the shorter edge on top, as this will stretch slightly as you stitch and should ease the problem. Press the seams to one side from the front of the joined squares.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/fig5_1_fmt.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-3"
    }
  }, [_vm._v("Fig 3")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("4 Pin and machine stitch the second pair of squares. Press the seams in the opposite direction to the first half ("), _c('a', {
    attrs: {
      "href": "#/#fig-4"
    }
  }, [_vm._v("Fig 4")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/fig7_1_fmt.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-4"
    }
  }, [_vm._v("Fig 4")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("5 Join the two halves by stitching across with a "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (6mm) seam, taking care to match the centre seams. Pressing the centre seams of each half in opposite directions will help match them accurately ("), _c('a', {
    attrs: {
      "href": "#/#fig-5"
    }
  }, [_vm._v("Fig 5")]), _vm._v("). Pin diagonally to help keep both sets of seam allowances flat while stitching. Press the final long seam to one side or open.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/rail-fence-fig5_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-5"
    }
  }, [_vm._v("Fig 5")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("6 Trim the block to an exact 12"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (31.7cm) square. Add framing sashing strips if desired. For a finished block of 14in (35.5cm) square, cut two strips 1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in × 12"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (3.2 × 31.7cm) and sew to the sides of the block. Press seams outwards. Cut two strips 1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in × 14in (3.2cm × 35.5cm) and sew to the top and bottom of the block and press.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d370bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 63
// module chunks = 0